export const config = {
    api : 'https://redux-ecommerce-backend.vercel.app'
}